import qs from 'qs';
import HOSTS from 'constants/hosts';

/**
 * Takes an object and returns a new object without pagination properties
 * @param {object} queryParams
 * @returns {object}
 */
const stripPaginationFromQueryParameters = queryParams => {
    const { spage, paging, page, fe, ...rest } = queryParams;
    return rest;
};

/**
 * Takes an object and returns a new object without itm properties
 * @param {object} queryParams
 * @returns {object}
 */
const stripItmFromQueryParameters = queryParams => {
    const { itm_source, itm_medium, ...rest } = queryParams;
    return rest;
};

/**
 * Creates search string from all properties in object
 * @param {object} queryParams
 * @param {{[addQueryPrefix]: bool, [encode]: bool, [skipNulls]: bool }}
 * @returns {string}
 */
const toSearchString = (
    queryParams,
    { addQueryPrefix = true, encode = true, skipNulls = true } = {}
) =>
    qs.stringify(queryParams, {
        addQueryPrefix: addQueryPrefix,
        encode: encode,
        skipNulls: skipNulls
    });

/**
 * Creates query parameters object from search string
 * @param {string} search
 */
const toQueryParameters = search =>
    qs.parse(search, { ignoreQueryPrefix: true });

/**
 * Takes an url and adds tradera base url if it is not already an absolute url
 * Removes leading slashes
 * @param {string} url
 * @returns {string}
 */
const toAbsoluteUrl = relativeUrl =>
    relativeUrl.startsWith('http')
        ? relativeUrl
        : `${HOSTS.TRADERA}${relativeUrl.replace(/^\/+/, '')}`;

/**
 * From react router location object to absolute url string
 * @param {{pathname: string, search: string}} url
 * @returns {string}
 */
const toAbsoluteUrlFromObject = url =>
    toAbsoluteUrl(
        `${url.pathname ? url.pathname : ''}${url.search ? url.search : ''}`
    );

export {
    toAbsoluteUrl,
    toAbsoluteUrlFromObject,
    toQueryParameters,
    toSearchString,
    stripPaginationFromQueryParameters,
    stripItmFromQueryParameters
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/url.js